import './bundleHeader.scss';
import { StateDTO } from '../../models/GeneralDTO';
import { TextField } from '@mui/material';
import { updateBundleValue } from '../../../actions/bundle';
import { useDispatch, useSelector } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import InputAdornment from '@material-ui/core/InputAdornment';
import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslation } from 'react-i18next';
import { Dropdown, MenuProps } from 'antd';

const BundleHeader = () => {
  const dispatch = useDispatch();
  const { companyId } = useSelector(
    (state: StateDTO) => state.bundle
  );

  const { t } = useTranslation();
  const addEquipmentMenu: MenuProps['items'] = [
    {
      key: 'bundle',
      onClick: () => {
        dispatch(
          updateBundleValue('newBundle', {
            security_coefficient: null,
            unit: 'Ensemble',
            name: "",
            lines: [
              {
                key: 0,
                caracs: null,
                quantity: null,
                AllotmentNode: null,
              },
            ],
            type_fiche: "bundle"
          })
        )
      },
      disabled: !companyId,
      label: <span>{t('APP.BUNDLE.BUNDLEMENU.ENSEMBLE', { defaultValue: 'Ensemble' })}</span>,    },
    {
      key: 'fichesconfig',
      onClick: () => {
        dispatch(
          updateBundleValue('newBundle', {
            security_coefficient: null,
            unit: "",
            name: "",
            ddv: 50,
            lines: [
              {
                key: 0,
                fileName: "",
                caracs: null,
                AllotmentNodes: null,
              },
            ],
            type_fiche: "FC"
          })
        )
      },
      disabled: !companyId,
      label: <span>{t('APP.BUNDLE.BUNDLELIST.BUNDLECARD.BUNDLECARDHEADER.CONFIGURED_SHEET', {
        defaultValue: 'Fiche configurée',
      })}</span>,
    },
    {
      key: 'modelingEquipmentCarbonWeight',
      label: <span>{t('APP.BUNDLE.BUNDLEMENU.PRODUIT_MODELISE_SAISIR', { defaultValue: 'Produit modélisé - Saisir' })}</span>,      disabled: !companyId,
      onClick: () => {
        dispatch(
          updateBundleValue('newBundle', {
            name: "",
            security_coefficient: null,
            ddv: null,
            unit: 'kg', 
            comment: "",
            lines: [ 
              {
                key: 0,
                modelingEquipmentCarbonWeightForm: {
                  endOfLife: null,
                  installation: null,
                  product: null,
                  profit: null,
                  usage: null
                }
              },
            ],
            type_fiche: "custom_user"
          })
        )
      },
    },
    {
      key: 'estimate',
      label: <span>{t('APP.BUNDLE.BUNDLEMENU.PRODUIT_MODELISE_ESTIMER', { defaultValue: 'Produit modélisé - Estimer' })}</span>,
      disabled: !companyId,
      onClick: () => {
        dispatch(
          updateBundleValue('newBundle', {
            name: "",
            security_coefficient: null,
            ddv: null, 
            unit: 'kg', 
            comment: "",
            lines: [
              {
                key: 0,
                manufacturedRate: 25,
                totalWeight: null,
                materialLines: []
              },
            ],
            type_fiche: "custom_user"
          })
        )
      },
    },
  ];

  return (
    <div className="bundle-header">
      <div className="input-search">
        <TextField
          placeholder={t('APP.BUNDLEHEADER.INDEX.PH_5AAABB', {
            defaultValue: 'Rechercher un ensemble',
          })}
          style={{ width: '100%' }}
          className="textFieldV1 searchProject"
          onChange={(e) =>
            dispatch(updateBundleValue('bundleSearchInput', e.target.value))
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className="projectTypeFilterWrapper">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.6678 18.7705L22.4589 17.8441C22.4815 17.652 22.5041 17.4712 22.5041 17.2791C22.5041 17.0871 22.4928 16.9063 22.4589 16.7142L23.6565 15.7878C23.7073 15.7443 23.7417 15.6847 23.754 15.619C23.7663 15.5532 23.7559 15.4852 23.7243 15.4263L22.5945 13.4717C22.5267 13.3248 22.3798 13.3248 22.233 13.3248L20.8433 13.8897C20.5383 13.6864 20.2332 13.4943 19.883 13.3587L19.6683 11.8674C19.6612 11.803 19.6309 11.7434 19.5831 11.6998C19.5353 11.6561 19.4732 11.6314 19.4085 11.6301H17.1488C17.0798 11.6288 17.0125 11.6519 16.9588 11.6953C16.9051 11.7387 16.8684 11.7996 16.8551 11.8674L16.6404 13.3587C16.3015 13.5056 15.9738 13.6864 15.6801 13.8897L14.2791 13.3248C14.1548 13.3248 14.008 13.3248 13.9289 13.4717L12.7991 15.4263C12.7313 15.5505 12.7539 15.6974 12.8669 15.7878L14.0645 16.7142C14.0194 17.0895 14.0194 17.4688 14.0645 17.8441L12.8669 18.7705C12.8161 18.814 12.7817 18.8736 12.7694 18.9393C12.7571 19.0051 12.7675 19.0731 12.7991 19.132L13.9289 21.0866C13.9967 21.2335 14.1435 21.2335 14.2791 21.2335L15.6801 20.6686C15.9738 20.8719 16.2902 21.064 16.6404 21.1996L16.8551 22.6909C16.8777 22.8265 16.9907 22.9282 17.1488 22.9282H19.4085C19.5327 22.9282 19.657 22.8265 19.6796 22.6909L19.8943 21.1996C20.2332 21.0527 20.5383 20.8719 20.8433 20.6686L22.233 21.2335C22.3798 21.2335 22.5267 21.2335 22.6058 21.0866L23.7356 19.132C23.7672 19.0731 23.7776 19.0051 23.7653 18.9393C23.753 18.8736 23.7186 18.814 23.6678 18.7705ZM18.2786 18.9739C17.3296 18.9739 16.5839 18.2169 16.5839 17.2791C16.5839 16.3414 17.3409 15.5844 18.2786 15.5844C19.2164 15.5844 19.9734 16.3414 19.9734 17.2791C19.9734 18.2169 19.2164 18.9739 18.2786 18.9739ZM17.8493 0.580589C17.6347 0.422416 17.3974 0.332031 17.1488 0.332031H1.33153C1.08297 0.332031 0.845712 0.422416 0.631049 0.580589C0.39654 0.765365 0.244702 1.03545 0.208713 1.33183C0.172723 1.62821 0.25551 1.92679 0.438981 2.16232L5.85076 9.08804V14.8727C5.80557 15.2003 5.91855 15.5505 6.1784 15.8104L10.7089 20.3409C10.8219 20.4539 10.9349 20.533 11.1044 20.5895C10.6185 19.5388 10.37 18.409 10.37 17.2791C10.37 15.2116 11.1835 13.2231 12.6296 11.7431V9.08804L18.0414 2.16232C18.2249 1.92679 18.3076 1.62821 18.2717 1.33183C18.2357 1.03545 18.0838 0.765365 17.8493 0.580589ZM10.37 8.29718V16.8046L8.11038 14.545V8.30847L3.63634 2.59165H14.844L10.37 8.29718Z"
            fill="#A3AED0"
          />
        </svg>
        {/* <div className={`tag ${projectTypeFilter.length === 0 ? 'disabled' : ''}`}>
                  {projectTypeFilter.length}
                 </div> */}
      </div>
      {/* Add Button */}
      <Dropdown
        placement="bottom"
        trigger={['hover']}
        disabled={!companyId}
        menu={{ items: addEquipmentMenu }}
        overlayClassName={'customDropdown'}
      >
        <button
          className={`nooco-button ${companyId ? "purple-button" : "close-button"}  add-Dropdown `}
          style={{ cursor: companyId ? "" : "not-allowed"}}
        >
          {t('APP.BUNDLEHEADER.INDEX.NEW', {
            defaultValue: 'Nouveau',
          })}
          <AddIcon />
        </button>
      </Dropdown>
    </div>
  );
};

export default BundleHeader;
